import moment from 'moment';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import UserAvatar from 'react-user-avatar';

function ViewEmpSalarySlip() {
    const navigate = useNavigate();
    const location = useLocation();
    const salaryData = location.state.data.allData;

    const salaryDetail = salaryData?.salary_details?.[0] || {};
    const earnings = salaryDetail.earning || {};
    const deductions = salaryDetail.deduction || {};

    const totalEarnings = Object.values(earnings).reduce((sum, value) => sum + (parseFloat(value) || 0), 0);
    const totalDeductions = Object.values(deductions).reduce((sum, value) => sum + (parseFloat(value) || 0), 0);

    return (
        <div className='TaskEmployee-main mb-5'>
            <div className="page-title">
                <h4>Salary Slip</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel</button>
                </div>
            </div>

            <div className='row'>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                    <div className='View_Timesheet_Card'>
                        <div className='head_timesheet'>
                            <h6>Salary Slip Details</h6>
                        </div>
                        <div className='body_timesheet row w-100'>
                            <div className="col-md-6">
                                <div className='labeldiv_timesheet'>
                                    <h5>Transaction ID</h5>
                                    <h6>{salaryData?.transaction_id || "--"}</h6>
                                </div>
                                <div className='labeldiv_timesheet'>
                                    <h5>Pay Period</h5>
                                    <h6>{salaryData?.pay_period ? moment(salaryData.pay_period).format("DD-MM-YYYY") : "--"}</h6>
                                </div>
                                <div className='labeldiv_timesheet'>
                                    <h5>Pay Date</h5>
                                    <h6>{salaryData?.pay_date ? moment(salaryData.pay_date).format("DD-MM-YYYY") : "--"}</h6>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='labeldiv_timesheet'>
                                    <h5>Working Days</h5>
                                    <h6>{salaryData?.day || "--"}</h6>
                                </div>
                                <div className='labeldiv_timesheet'>
                                    <h5>Loss Pay Days</h5>
                                    <h6>{salaryData?.loss_pay_day || 0}</h6>
                                </div>
                                <div className='labeldiv_timesheet align-items-center'>
                                    <h5 className='m-0'>Employee</h5>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {salaryData?.user?.profile_pic?.data ? (
                                            <img
                                                width={30}
                                                height={30}
                                                style={{ borderRadius: '50%' }}
                                                src={`data:image/jpeg;base64,${btoa(
                                                    new Uint8Array(salaryData?.user?.profile_pic?.data).reduce(
                                                        (data, byte) => data + String.fromCharCode(byte),
                                                        ''
                                                    )
                                                )}`} alt="Employee Profile Pic" />
                                        ) : (
                                            <UserAvatar
                                                name={salaryData?.name || salaryData?.user?.name || "Unknown"}
                                                size={30}
                                                style={{ textTransform: 'uppercase', color: 'white' }}
                                                color="#5757fe"
                                            />
                                        )}
                                        <h6 style={{ marginLeft: '10px', marginTop: '5px' }}>
                                            {salaryData?.name || salaryData?.user?.name || "--"}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Earnings Section */}
                <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className='View_Timesheet_Card'>
                        <div className='head_timesheet'>
                            <h6>Earnings</h6>
                        </div>
                        <div className='body_timesheet'>
                            {Object.entries(earnings).map(([key, value]) => (
                                <div key={key} className='labeldiv_timesheet'>
                                    <h5 className='me-3'>{key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</h5>
                                    <h6>₹{value || 0}</h6>
                                </div>
                            ))}
                            <div className='labeldiv_timesheet' style={{ borderTop: '1px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>
                                <h5><strong>Total Earnings</strong></h5>
                                <h6><strong>₹{totalEarnings.toFixed(2)}</strong></h6>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Deductions Section */}
                <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className='View_Timesheet_Card'>
                        <div className='head_timesheet'>
                            <h6>Deductions</h6>
                        </div>
                        <div className='body_timesheet'>
                            {Object.entries(deductions).map(([key, value]) => (
                                <div key={key} className='labeldiv_timesheet'>
                                    <h5>{key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</h5>
                                    <h6>₹{value || 0}</h6>
                                </div>
                            ))}
                            <div className='labeldiv_timesheet' style={{ borderTop: '1px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>
                                <h5><strong>Total Deductions</strong></h5>
                                <h6><strong>₹{totalDeductions.toFixed(2)}</strong></h6>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Net Pay Section */}
                <div className='col-lg-12 col-md-12 col-sm-12 View_Timesheet_Card'>
                    <div className='d-flex align-items-center justify-content-between w-100'>
                        <div className='head_timesheet border-0'>
                            <h5>Net Pay Summary</h5>
                            <h6>Gross Earnings - Total Deductions</h6>
                        </div>
                        <div className=''>
                            <h5><strong>₹{salaryData?.total_pay || (totalEarnings - totalDeductions).toFixed(2)}</strong></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewEmpSalarySlip